import React, { useState, createContext } from "react";
import axios from "axios"
import { useEffect } from "react"

export const MovieContext = createContext();

export const MovieProvider = (props) => {
  const [listOfMovie, setListOfMovie] = useState([]);
    
  useEffect( () => {
    const movies = async () => {
      const result = await axios.get("https://super-bootcamp-backend.sanbersy.com/api/movies")
          .then((res) => {
              return res.data
          })
          .catch((err) =>{
              console.log(err)
          })

          setListOfMovie(result)
    }
    movies()
  }, [])

  return (
    <MovieContext.Provider value={[listOfMovie, setListOfMovie]}>
      {props.children}
    </MovieContext.Provider>
  );
};
